import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

// Actions
import { logout } from "../../actions/userActions";
import ToggleCountry from "./ToggleCountry";
import { Menu } from "lucide-react";
import { ShoppingCart } from "lucide-react";
import { SwatchBook } from "lucide-react";
import { UserPlus2 } from "lucide-react";
import { User2 } from "lucide-react";
import { ArrowDown } from "lucide-react";
import { X } from "lucide-react";
import { allProducts } from "../../screens/shop/data";

const Header = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const isMobile = useMediaQuery({ maxWidth: 820 });

	// States
	const [isOpen, setIsOpen] = useState(false);
	const [activeDropdown, setActiveDropdown] = useState(null);
	const [isScrolled, setIsScrolled] = useState(false);
	const [openSubMenus, setOpenSubMenus] = useState({});

	// Redux selectors
	const cartItems = useSelector((state) => state.cart?.cartItems);
	const swatchCartItems = useSelector(
		(state) => state.swatchCart?.swatchCartItems
	);
	const userLogin = useSelector((state) => state.userLogin);
	const userInfo = !userLogin?.isGuest ? userLogin?.userInfo : null;

	// Animation constants
	const bounceTransition = {
		duration: 0.4,
		ease: [0.68, -0.25, 0.265, 1.25],
	};

	// Navigation items
	const navItems = [
		{
			label: "Shop",
			link: "/shop",
			// submenu: allProducts.map((product) => ({
			// 	label: product.name.replace(" Shade", ""),
			// 	link: `/shop/info/${product.type.toLowerCase().replaceAll(" ", "_")}`,
			// })),
		},
		{ label: "Motorization", link: "/motorized-solutions" },
		{
			label: "Blog",
			link: "/blog",
		},
		// { label: "Special Offer", link: "/special-offer" },

		{
			label: "Help",
			link: "#",
			submenu: [
				{
					label: "Guides",
					link: "#",
					submenu: [
						{
							label: "Fabric Guide",
							link: "/guides/productselection",
						},
						{
							label: "Measuring Guide",
							link: "/guides/measuring-guide",
						},
						{
							label: "Installation Guide",
							link: "/guides/installation-guide",
						},
					],
				},
				{
					label: "Privacy Policy",
					link: "/help/privacy-policy",
				},
				{
					label: "Shipping Policy",
					link: "/help/shipping-policy",
				},
				{
					label: "Guarantee",
					link: "/help/return-policy",
				},
				{
					label: "Terms & Conditions",
					link: "/help/terms-conditions",
				},
				{
					label: "Warranty",
					link: "/help/warranty",
				},
			],
		},
		{ label: "About Us", link: "/about" },
		{ label: "Contact Us", link: "/contact" },
	];

	const profileSubMenu = [
		{ label: "Profile", to: "/profile" },
		{ label: "Orders", to: "/myorders" },
		{
			label: "Logout",
			onClick: () => dispatch(logout()),
		},
	];
	// Tips data

	// const tips = [
	// 	{
	// 		name: "Not sure what fabric to choose? Click here to try our FREE Samples. No cost involved!",
	// 		href: "/swatches",
	// 	},
	// 	{
	// 		name: "Our customization tool lets you design your own shade from scratch. Try it now!",
	// 		href: "/shop",
	// 	},
	// 	{
	// 		name: "We offer free shipping on all orders with a 2 day turnaround. Click here for more information.",
	// 		href: "/help/shipping-policy",
	// 	},
	// 	{
	// 		name: "Want to know the best way to measure your windows? Click here for our guide.",
	// 		href: "/help/measuring-guide",
	// 	},
	// 	{
	// 		name: "If you are unsure on how to install your shades, click here for our installation guide.",
	// 		href: "/help/installation-guide",
	// 	},
	// 	{
	// 		name: "We offer a 5 year warranty on all our products so you can shop with confidence.",
	// 		href: "/help/warranty",
	// 	},
	// 	{
	// 		name: "Don't like waiting and require immediate assistance? Click the chat icon to speak to a representative.",
	// 		href: "/",
	// 	},
	// 	{
	// 		name: "Refer a friend and get credits on your next order while your friend gets 10% off their first order. It's a win-win!",
	// 		href: "/login",
	// 	},
	// 	{
	// 		name: "Need further help? Contact us for a free consultation.",
	// 		href: "/contact",
	// 	},
	// ];

	// Handle scroll effect
	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(window.scrollY > 50);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	useEffect(() => {
		setActiveDropdown(null);
		setIsOpen(false);
		setOpenSubMenus({});
	}, [location.pathname]);

	if (location.pathname === "/special-offer") return null;

	return (
		<motion.header
			className="sticky w-full top-0 z-50 bg-secondary shadow-md"
			initial={{ y: -20 }}
			animate={{ y: 0 }}
			transition={bounceTransition}
		>
			{/* Announcement Bar */}
			{/* <motion.div
				animate={{
					opacity: isScrolled ? 0 : 1,
					height: isScrolled ? 0 : "auto",
				}}
				className="bg-primary text-white"
			>
				<Carousel
					key={location.pathname}
					autoPlay={true}
					animation="slide"
					indicators={false}
					swipe={false}
					navButtonsAlwaysInvisible={true}
					interval={5000}
					className="h-10"
				>
					{tips.map((tip, index) => (
						<motion.div
							key={index}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							transition={bounceTransition}
							className="h-10 flex items-center justify-center"
						>
							<Link
								to={tip.href}
								className="text-sm text-white hover:underline px-4 text-center"
							>
								{tip.name}
							</Link>
						</motion.div>
					))}
				</Carousel>
			</motion.div> */}

			{/* Main Navigation */}
			<div className="bg-secondary">
				<div className="container mx-auto px-4">
					<div className="flex items-center justify-between h-16">
						{/* Logo */}
						<Link to="/" className="flex-shrink-0">
							<motion.img
								src="/images/logoDark-1.png"
								alt="Off Cut Shades"
								className="h-12"
								whileHover={{ scale: 1.05 }}
								transition={bounceTransition}
							/>
						</Link>

						{/* Desktop Navigation */}
						{!isMobile && (
							<div className="flex items-center space-x-8">
								<nav className="flex items-center space-x-6">
									{navItems.map((item, index) => {
										const itemUrl = item.link.split("/");
										return (
											<div key={index} className="relative group">
												<motion.div
													className="flex items-center"
													onHoverStart={() => setActiveDropdown(item.label)}
													onHoverEnd={() => setActiveDropdown(null)}
												>
													<Link
														to={item.link}
														className={`text-sm transition-colors ${
															location.pathname.includes(
																itemUrl[itemUrl.length - 1]
															)
																? "px-4 py-2 bg-primary text-white rounded-xl hover:bg-primary/90"
																: "text-white "
														}`}
													>
														<span className="flex items-center gap-1">
															{item.label}
															{item.submenu && (
																<ArrowDown className="w-4 h-4 transition-transform duration-200 group-hover:rotate-180" />
															)}
														</span>
													</Link>

													{/* Dropdown */}
													{item.submenu && (
														<AnimatePresence>
															{activeDropdown === item.label && (
																<motion.div
																	initial={{ opacity: 0, y: 10 }}
																	animate={{ opacity: 1, y: 0 }}
																	exit={{ opacity: 0, y: 10 }}
																	transition={bounceTransition}
																	className="absolute top-full left-0 w-[240px] p-2 mt-1 bg-secondary rounded-xl shadow-xl"
																>
																	{item.submenu.map((subItem, subIndex) => (
																		<div
																			key={subIndex}
																			className="relative group/submenu"
																		>
																			<Link
																				to={
																					subItem.submenu ? "#" : subItem.link
																				}
																				className="block px-4 py-2 text-sm text-white hover:bg-primary transition-colors rounded-xl duration-200 flex items-center justify-between"
																			>
																				{subItem.label}
																				{subItem.submenu && (
																					<ArrowDown className="w-4 h-4 -rotate-90" />
																				)}
																			</Link>

																			{/* Nested Submenu */}
																			{subItem.submenu && (
																				<div className="absolute left-full top-[-10px] w-[240px] p-2 mt-0 ml-1 bg-secondary rounded-xl shadow-xl hidden group-hover/submenu:block">
																					{subItem.submenu.map(
																						(nestedItem, nestedIndex) => (
																							<Link
																								key={nestedIndex}
																								to={nestedItem.link}
																								className="block px-4 py-2 text-sm text-white hover:bg-primary transition-colors rounded-xl duration-200"
																							>
																								{nestedItem.label}
																							</Link>
																						)
																					)}
																				</div>
																			)}
																		</div>
																	))}
																</motion.div>
															)}
														</AnimatePresence>
													)}
												</motion.div>
											</div>
										);
									})}
								</nav>

								{/* Right Icons */}
								<div className="flex items-center space-x-6">
									{[
										{
											to: "/refer-a-friend",
											icon: <UserPlus2 />,
											label: "Refer",
										},
										{
											to: "/swatches",
											icon: <SwatchBook />,
											count: swatchCartItems?.length,
											label: "Samples",
										},
										{
											to: "/cart",
											icon: <ShoppingCart />,
											count: cartItems?.length,
											label: "Cart",
										},
										{
											to: userInfo ? "/profile" : "/login",
											icon: <User2 />,
											label: userInfo ? `Hello, ${userInfo.name}` : "Account",
											subMenu: profileSubMenu,
										},
									].map((item, index) => (
										<div key={index} className="relative group">
											<motion.div
												whileHover={{ scale: 1.1 }}
												whileTap={{ scale: 0.95 }}
												transition={bounceTransition}
												onHoverStart={() =>
													item.subMenu && setActiveDropdown("profile")
												}
												onHoverEnd={() =>
													item.subMenu && setActiveDropdown(null)
												}
											>
												{item.to ? (
													<Link
														to={item.to}
														className="text-white  flex flex-col items-center"
													>
														<div className="relative">
															{item.icon}
															{item.count > 0 && (
																<motion.span
																	initial={{ scale: 0 }}
																	animate={{ scale: 1 }}
																	className="absolute -top-2 -right-2 bg-primary text-white text-xs w-5 h-5 rounded-full flex items-center justify-center"
																>
																	{item.count}
																</motion.span>
															)}
														</div>
														<span className="text-xs mt-1">{item.label}</span>
													</Link>
												) : (
													<div className="text-white  flex flex-col items-center cursor-pointer">
														<div className="relative">
															{item.icon}
															{item.count > 0 && (
																<motion.span
																	initial={{ scale: 0 }}
																	animate={{ scale: 1 }}
																	className="absolute -top-2 -right-2 bg-primary text-white text-xs w-5 h-5 rounded-full flex items-center justify-center"
																>
																	{item.count}
																</motion.span>
															)}
														</div>
														<span className="text-xs mt-1 flex items-center gap-1">
															{item.label}
															{item.subMenu && (
																<ArrowDown className="w-4 h-4 transition-transform duration-200 group-hover:rotate-180" />
															)}
														</span>
													</div>
												)}

												{/* Profile Dropdown */}
												{userInfo && item.subMenu && (
													<AnimatePresence>
														{activeDropdown === "profile" && (
															<motion.div
																initial={{ opacity: 0, y: 10 }}
																animate={{ opacity: 1, y: 0 }}
																exit={{ opacity: 0, y: 10 }}
																transition={bounceTransition}
																className="absolute top-full right-0 w-48 p-2 mt-1 bg-secondary rounded-xl shadow-xl"
															>
																{item.subMenu.map((subItem, subIndex) =>
																	subItem.to ? (
																		<Link
																			key={subIndex}
																			to={subItem.to}
																			className="block px-4 py-2 text-sm text-white hover:bg-primary transition-colors rounded-xl duration-200"
																		>
																			{subItem.label}
																		</Link>
																	) : (
																		<button
																			key={subIndex}
																			onClick={subItem.onClick}
																			className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-primary transition-colors rounded-xl duration-200"
																		>
																			{subItem.label}
																		</button>
																	)
																)}
															</motion.div>
														)}
													</AnimatePresence>
												)}
											</motion.div>
										</div>
									))}
									<ToggleCountry />
								</div>
							</div>
						)}

						{/* Mobile Menu Button */}
						{isMobile && (
							<motion.button
								whileTap={{ scale: 0.95 }}
								onClick={() => setIsOpen(!isOpen)}
								className="text-white p-2"
							>
								{isOpen ? <X /> : <Menu />}
							</motion.button>
						)}
					</div>
				</div>
			</div>

			<AnimatePresence>
				{isMobile && (
					<motion.div
						initial={{ opacity: 0, height: 0 }}
						animate={{ opacity: 1, height: "auto" }}
						exit={{ opacity: 0, height: 0 }}
						transition={bounceTransition}
						className="bg-secondary border-t border-gray-800"
					>
						{isOpen && (
							<div className="p-4 space-y-2">
								{navItems.map((item, index) => {
									const submenuOpen = !!openSubMenus[index];
									return (
										<div key={index}>
											<Link
												to={item.submenu ? "#" : item.link}
												onClick={() => {
													if (item.submenu) {
														setOpenSubMenus({
															...openSubMenus,
															[index]: !submenuOpen,
														});
													} else {
														setIsOpen(false);
													}
												}}
												className={`flex gap-4 items-center w-full text-left py-3 px-4 text-white rounded-xl ${
													item.highlight
														? "my-2 bg-primary text-white hover:bg-primary/90"
														: ""
												} ${
													openSubMenus[index]
														? "bg-primary text-white transition-all"
														: ""
												}`}
											>
												{item.label}
												{item.submenu && (
													<ArrowDown
														className={`w-4 h-4 transition-transform duration-200 ${
															submenuOpen ? "rotate-180" : ""
														}`}
													/>
												)}
											</Link>
											{item.submenu && submenuOpen && (
												<div className="pl-8 space-y-2 mt-2">
													{item.submenu.map((subItem, subIndex) => (
														<div key={subIndex}>
															{subItem.submenu ? (
																<>
																	<Link
																		to="#"
																		className="flex items-center justify-between py-2 text-gray-300 hover:text-primary"
																		onClick={() => {
																			setOpenSubMenus({
																				...openSubMenus,
																				[`${index}-${subIndex}`]:
																					!openSubMenus[`${index}-${subIndex}`],
																			});
																		}}
																	>
																		{subItem.label}
																		<ArrowDown
																			className={`w-4 h-4 transition-transform duration-200 ${
																				openSubMenus[`${index}-${subIndex}`]
																					? "rotate-180"
																					: ""
																			}`}
																		/>
																	</Link>
																	{openSubMenus[`${index}-${subIndex}`] && (
																		<div className="pl-4 space-y-2 mt-2">
																			{subItem.submenu.map(
																				(nestedItem, nestedIndex) => (
																					<Link
																						key={nestedIndex}
																						to={nestedItem.link}
																						className="block py-2 text-gray-300 hover:text-primary"
																						onClick={() => setIsOpen(false)}
																					>
																						{nestedItem.label}
																					</Link>
																				)
																			)}
																		</div>
																	)}
																</>
															) : (
																<Link
																	to={subItem.link}
																	className="block py-2 text-gray-300 hover:text-primary"
																	onClick={() => setIsOpen(false)}
																>
																	{subItem.label}
																</Link>
															)}
														</div>
													))}
												</div>
											)}
										</div>
									);
								})}
								{/* Mobile Icons */}
								<div className="flex items-center justify-around py-4 border-t">
									<ToggleCountry />
									<Link
										to="/refer-a-friend"
										className="text-gray-300 hover:text-primary"
									>
										<UserPlus2 />
									</Link>
									<Link
										to="/swatches"
										className="text-gray-300 hover:text-primary relative"
									>
										<SwatchBook />
										{swatchCartItems?.length > 0 && (
											<span className="absolute -top-2 -right-2 bg-primary text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
												{swatchCartItems.length}
											</span>
										)}
									</Link>
									<Link
										to="/cart"
										className="text-gray-300 hover:text-primary relative"
									>
										<ShoppingCart />
										{cartItems?.length > 0 && (
											<span className="absolute -top-2 -right-2 bg-primary text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
												{cartItems.length}
											</span>
										)}
									</Link>
									<Link
										to={userInfo ? "/profile" : "/login"}
										className="text-gray-300 hover:text-primary"
										onClick={() =>
											userInfo &&
											setActiveDropdown(
												activeDropdown === "profile" ? null : "profile"
											)
										}
									>
										<User2 />
										{userInfo && (
											<AnimatePresence>
												{activeDropdown === "profile" && (
													<motion.div
														initial={{ opacity: 0, y: 10 }}
														animate={{ opacity: 1, y: 0 }}
														exit={{ opacity: 0, y: 10 }}
														transition={bounceTransition}
														className="absolute top-full right-0 w-48 p-2 mt-1 bg-secondary rounded-xl shadow-xl"
													>
														{profileSubMenu.map((subItem, subIndex) =>
															subItem.to ? (
																<Link
																	key={subIndex}
																	to={subItem.to}
																	className="block px-4 py-2 text-sm text-white hover:bg-primary transition-colors rounded-xl duration-200"
																>
																	{subItem.label}
																</Link>
															) : (
																<button
																	key={subIndex}
																	onClick={subItem.onClick}
																	className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-primary transition-colors rounded-xl duration-200"
																>
																	{subItem.label}
																</button>
															)
														)}
													</motion.div>
												)}
											</AnimatePresence>
										)}
									</Link>
								</div>
							</div>
						)}
					</motion.div>
				)}
			</AnimatePresence>
		</motion.header>
	);
};

export default Header;
